import React from "react";
import Rating from "@material-ui/lab/Rating";
import getProfileLabel from "../../genericFunctions/getProfileLabel";

const PrintSkillsPage = (props) => {
  const skills = props.skills;
  const label = (key) => getProfileLabel(props.language, key);


  
  return (
    <div
      className="print-font"
      style={{
        paddingRight: "15px",
        maxWidth: "100%",
      }}
    >
      <h3
        style={{
          marginBottom: "10px ",
          background: "#ffffff",
        }}
      >
        {" "}
        {label("skills")}
        <div className="print-border"></div>
      </h3>
      <div>
        {skills.length <= 0 ? (
          <p style={{ marginTop: "1rem", marginBottom: "1rem" }}>
            {label("noSkills")}
          </p>
        ) : (
          skills.map((skill) => {
            return (
              <div
                style={{
                  display: "flex",
                  alignItems: "left",
                  flexDirection: "column",
                }}
                key={skill._id}
              >
                <p style={{ marginBottom: "0px", fontSize: "1.25rem" }}>
                  {skill.name}
                </p>
                <Rating
                  value={parseInt(skill.stars)}
                  readOnly
                  style={{ marginBottom: "5px" }}
                />
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default PrintSkillsPage;
